export const SHOW_WELCOME_MODAL = "SHOW_WELCOME_MODAL";
export const SHOW_TUTORIAL_MODAL = "SHOW_TUTORIAL_MODAL";
export const SET_TUTORIAL = "SET_TUTORIAL";
export const SHOW_STEPS_BANNER = "SHOW_STEPS_BANNER";
export const SHOW_FREQUENT_QUESTIONS_DRAWER = "SHOW_FREQUENT_QUESTIONS_DRAWER";
